import { useEffect } from 'react';
import { usePrevious } from 'site-modules/shared/hooks/use-previous';

export function useRestoreFocusToElement({ element, restore }) {
  const prevRestore = usePrevious(restore);

  useEffect(() => {
    if (prevRestore === restore || !restore) {
      return;
    }

    if (!element) {
      // Reset focus from active element. New active element will be body by default
      document.activeElement?.blur();
      return;
    }

    setTimeout(() => {
      element.focus();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restore]);
}
